export function hasPermission(userPermissions, required) {
    return userPermissions.includes(required) || userPermissions.includes('system:full_access');
}
export function hasAnyPermission(userPermissions, required) {
    if (userPermissions.includes('system:full_access'))
        return true;
    return required.some((permission) => userPermissions.includes(permission));
}
export function hasAllPermissions(userPermissions, required) {
    if (userPermissions.includes('system:full_access'))
        return true;
    return required.every((permission) => userPermissions.includes(permission));
}
export function resolvePermissions(memberships, roles) {
    const roleMap = new Map();
    for (const role of roles) {
        roleMap.set(role.id, role);
    }
    const permissionSet = new Set();
    for (const membership of memberships) {
        if (membership.status !== 'active') {
            continue;
        }
        const role = roleMap.get(membership.roleId);
        if (!role) {
            continue;
        }
        for (const permission of role.permissions) {
            permissionSet.add(permission);
        }
    }
    return Array.from(permissionSet);
}
